/**
 * One-shot, in-memory handoff for text that prefills the support-request form: what a patient
 * typed into the AI chat reason picker when their topic is routed to the ordinary form
 * (Medication, Account, Other), the `message` of an inbound new-support-request deep link, and
 * the fixed upgrade request from the Weight Management paywall modal.
 *
 * Deliberately neither a query parameter nor storage. A `?message=` param puts the patient's own
 * words into browser history and into RUM `view.url` / `view.referrer` telemetry, and
 * `mask-user-input` masks DOM text, not URLs. Session or local storage would outlive the
 * navigation the draft exists for. A module-level variable lives exactly as long as the page: it
 * is set immediately before the navigation and taken — read and cleared in one step — by the
 * form that mounts as a result, so it cannot be read twice or surface for a later patient in the
 * same tab.
 */
let pendingDraft: string | null = null;

export const setSupportRequestDraft = (draft: string) => {
  pendingDraft = draft.trim() || null;
};

/** Returns the pending draft and clears it, so a second reader sees nothing. */
export const takeSupportRequestDraft = (): string | null => {
  const draft = pendingDraft;
  pendingDraft = null;

  return draft;
};

export const clearSupportRequestDraft = () => {
  pendingDraft = null;
};
